// extracted by mini-css-extract-plugin
export default {"stepsContainer":"Steps_stepsContainer__PPJw+","is-pending":"Steps_is-pending__IJJIF","is-active":"Steps_is-active__t+0Co","ar":"Steps_ar__QUxmh","rejected":"Steps_rejected__+DuWw"};